import { type FC } from "react"

import { usePlatform } from "~/contexts/PlatformContext"
import useGreeting from "~/hooks/useGreeting"
import Layout from "~/themes/school/components/Layout"
import { PageTitle } from "~/themes/school/components/PageHeader"
import PartialLoadingPage from "~/themes/school/components/PartialLoadingPage"
import { useTranslation } from "~/translations"
import { query } from "~/utilities/trpc"

import ActiveCourses from "./ActiveCourses"
import { Calendar } from "./Calendar"
import Gamification from "./Gamification"

const DashboardPage: FC = () => {
	const platform = usePlatform().platform
	const t = useTranslation()
	const greeting = useGreeting()

	if (platform.brandId === "goran") return <GoranDashboard />

	return (
		<Layout>
			<PageTitle>{greeting ?? t("dashboard.title")}</PageTitle>
			<div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,400px)_minmax(0,400px)]">
				{platform.content.courses && <ActiveCourses className="row-span-2" />}
				<Calendar />
				<Gamification />
			</div>
		</Layout>
	)
}

const GoranDashboard: FC = () => {
	const greeting = useGreeting()
	const t = useTranslation()

	const { data, error } = query.platform.getStudentDashboardHtml.useQuery()

	return (
		<Layout>
			<PageTitle>{greeting ?? t("dashboard.title")}</PageTitle>
			{error ? (
				<p>Failed to load dashboard.</p>
			) : data === undefined ? (
				<PartialLoadingPage />
			) : (
				data && (
					<div className="bg-white p-6 shadow">
						<div className="editorjs" dangerouslySetInnerHTML={{ __html: data }} />
					</div>
				)
			)}
		</Layout>
	)
}

export default DashboardPage
